var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-widget"},[_c('img',{staticClass:"embedded-image",style:(_vm.imageDimensions),attrs:{"src":_vm.imagePath}})])}
var staticRenderFns = []

export { render, staticRenderFns }